var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isLoading,"can-cancel":false}}),_c('b-notification',{attrs:{"active":_vm.isError,"indefinite":"true","type":"is-danger","role":"alert","message":_vm.error,"closable":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }